// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__T2cmS","name":"Header_name__1zjAe","birthday":"Header_birthday__S-IR9","skeleton":"Header_skeleton__325py"};